import React from "react";
import CloudflareVideoPlayer from "./CloudflareVideoPlayer";

function App() {
  return (
    <div className="App">
      <h1>Live Stream</h1>
      <CloudflareVideoPlayer />
    </div>
  );
}

export default App;
